/** 战略/项目场景使用的三大事业部口径 */
export const STRATEGY_BUSINESS_UNIT_DEFS = [
  {label: '安全事业部', match: name => /安全/.test(name)},
  {label: '健康事业部', match: name => /健康/.test(name)},
  {label: '传媒事业部', match: name => /传媒|文化/.test(name)}
];

/** 解析数字型 organization_id；事业部主键 BU 编号请走 businessUnitSysno */
export function normalizeOrganizationId(value) {
  if (value == null || value === '') return null;
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  const text = String(value).trim();
  if (!text || !/^\d+$/.test(text)) return null;
  return Number(text);
}

export function businessUnitSysno(value) {
  if (value == null || value === '') return null;
  const text = String(value).trim();
  return text || null;
}

export function collectBusinessUnitRows(source) {
  const flat = [];
  const walk = (items) => {
    if (!Array.isArray(items)) return;
    items.forEach(x => {
      const name = String((x && (x.name || x.businessUnit || x.BusinessUnit)) || '').trim();
      const rawId = x && (x.id != null ? x.id : (x.businessUnitSysno != null ? x.businessUnitSysno : x.organizationId));
      if (name && rawId != null && rawId !== '') flat.push({id: rawId, name});
      walk(x && (x.children || x.functionCenters));
    });
  };
  if (Array.isArray(source)) walk(source);
  else if (source && Array.isArray(source.businessUnits)) walk(source.businessUnits);
  else if (source && Array.isArray(source.nodes)) walk(source.nodes);
  return flat;
}

/** 归并为主数据三大事业部；始终返回 3 项供选择器展示 */
export function buildStrategyUnitOptions(rawRows) {
  const skip = name => /院长|总经办/.test(name);
  const rows = (rawRows || []).filter(x => x && x.name && !skip(x.name));
  return STRATEGY_BUSINESS_UNIT_DEFS.map(def => {
    const hit = rows.find(x => def.match(String(x.name || '')))
      || rows.find(x => String(x.name || '').trim() === def.label);
    const sysno = hit ? businessUnitSysno(hit.id) : null;
    return {
      name: def.label,
      id: sysno ? normalizeOrganizationId(sysno) : null,
      businessUnitSysno: sysno
    };
  });
}

export function strategyNodeBusinessUnitSysno(node) {
  if (!node) return null;
  return businessUnitSysno(node.business_unit_sysno != null ? node.business_unit_sysno : node.businessUnitSysno);
}

export function matchesBusinessUnit(node, unit) {
  if (!unit) return true;
  const nodeSysno = strategyNodeBusinessUnitSysno(node);
  if (unit.businessUnitSysno && nodeSysno) return nodeSysno === unit.businessUnitSysno;
  const nodeOrgId = normalizeOrganizationId(node && (node.organization_id != null ? node.organization_id : node.organizationId));
  if (unit.id != null && nodeOrgId != null) return nodeOrgId === unit.id;
  return false;
}



// WEBPACK FOOTER //
// ./src/utils/businessUnits.js